import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/backIndex.png'


import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useTaskStore } from '@/stores/task'
import { useAuthStore } from '@/stores/login'
import { FloatingBubble } from 'vant'

// /examInfo

export default /*@__PURE__*/_defineComponent({
  __name: 'BackIndexsuspendBall',
  setup(__props) {

const excludeRouteList = [
  'ExamInfo',
  'surveyInfo',
  'surveyDetails',
  'trainingDetail',
  'courseDetail',
  'comDetailLevel',
  'broadcastDetail'
] // 需要展示悬浮球的各个详情页面路由 , 'rollVideo'
const route = useRoute()
const router = useRouter()
const { availWidth, availHeight } = window.screen
const offset = ref({ x: availWidth - 60, y: availHeight - 250 })
const path = route.name as string
const showBubble = ref(excludeRouteList.includes(path))
const taskStore = useTaskStore()
const { showTaskSwitch } = storeToRefs(taskStore)
const { getAccessToken } = storeToRefs(useAuthStore())

const openDrawer = () => {
  router.replace('/')
}

watch(
  () => route.name,
  (newVal) => {
    showBubble.value = excludeRouteList.includes(newVal)
  }
)

return (_ctx: any,_cache: any) => {
  return (showBubble.value && !_unref(showTaskSwitch) && _unref(getAccessToken))
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        _createVNode(_unref(FloatingBubble), {
          class: "bubbleStyle",
          offset: offset.value,
          "onUpdate:offset": _cache[0] || (_cache[0] = ($event: any) => ((offset).value = $event)),
          axis: "xy",
          magnetic: "x",
          onClick: openDrawer
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "back-index" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                srcset: ""
              })
            ], -1)
          ])),
          _: 1,
          __: [1]
        }, 8, ["offset"])
      ]))
    : _createCommentVNode("", true)
}
}

})